import { Home, Users, Package, Settings, Menu as MenuIcon } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

const mobileNavItems = [
  { title: "الرئيسية", href: "/", icon: Home },
  { title: "العملاء", href: "/clients", icon: Users },
  { title: "الباقات", href: "/tourism-packages", icon: Package },
  { title: "الإعدادات", href: "/settings", icon: Settings },
];

interface MobileNavigationProps {
  onMenuClick: () => void;
}

export function MobileNavigation({ onMenuClick }: MobileNavigationProps) {
  const location = useLocation();
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-t lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-14 sm:h-16 px-2 pb-safe">
        {mobileNavItems.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center px-2 sm:px-3 py-2 text-xs font-medium transition-all duration-200 min-w-0 min-h-[44px]",
                isActive
                  ? "text-primary scale-105"
                  : "text-muted-foreground hover:text-foreground hover:scale-105"
              )}
            >
              <Icon className={cn("h-4 w-4 sm:h-5 sm:w-5 mb-1 transition-transform", isActive && "text-primary")} />
              <span className="truncate text-[10px] sm:text-xs">{item.title}</span>
            </Link>
          );
        })}
        
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center px-2 sm:px-3 py-2 text-xs font-medium text-muted-foreground hover:text-foreground hover:scale-105 transition-all duration-200 min-w-0 min-h-[44px]"
        >
          <MenuIcon className="h-4 w-4 sm:h-5 sm:w-5 mb-1" />
          <span className="text-[10px] sm:text-xs">المزيد</span>
        </Button>
      </div>
    </nav>
  );
}